<template>
  <div>
    <header class="modal-header">We are incredibly sorry for the issue.</header>
    <section class="modal-body">
      <h1>Would you prefer we come out and fix the problem or give you a {{ amount }} credit?</h1>
    </section>
    <footer class="modal-footer">
      <LsButton
        text="Fix Issue"
        track-id="return_request_credit_or_fix-fix"
        bg-color="primary"
        :loading="type === 'fix' && dispute.loadingStatus.isUpdating"
        :disabled="type === 'credit' && dispute.loadingStatus.isUpdating"
        @click="submit('fix')"
      />
      <LsButton
        :text="`${amount} Credit`"
        track-id="return_request_credit_or_fix-credit"
        bg-color="primary"
        :loading="type === 'credit' && dispute.loadingStatus.isUpdating"
        :disabled="type === 'fix' && dispute.loadingStatus.isUpdating"
        @click="submit('credit')"
      />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { DISPUTE__REQUEST_FIX_OR_CREDIT } from '@/store/types';
import { lsFilters } from 'ls-vue-common';

export default {
  name: 'ReturnRequestCreditOrFix',
  components: {
    LsButton,
  },
  data() {
    return {
      type: '',
    };
  },
  computed: {
    ...mapState(['dispute']),
    amount() {
      return lsFilters.currency({
        amount: this.dispute.currentDispute.credit_offered_amount,
        trimTrailingZeros: true,
      });
    },
  },

  methods: {
    ...mapActions([DISPUTE__REQUEST_FIX_OR_CREDIT]),
    submit(type) {
      this.type = type;
      this[DISPUTE__REQUEST_FIX_OR_CREDIT]({
        type: this.type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  button:first-of-type {
    margin-right: 5px;
  }

  button:last-of-type {
    margin-left: 5px;
  }
}
</style>
